import { navReturnsHeaderRowHeight } from '../download-data-styles';
import {
  renderMainLeftCell,
  renderMainRightCell,
  renderSoftLeftCell,
  renderSectionHeaderAsOfDate,
  renderRowGaps,
  renderColumnGaps
} from '../helpers';

export const formatReturnsValue = val => {
  if (val === 'N/A' || isNaN(val) || val === '--') {
    return 'N/A';
  }
  return `${val}%`;
};

export const returnsAtNavHeaderRow = headers => {
  let headerString = `<tr>`;
  headerString += `<td style="${navReturnsHeaderRowHeight}"></td>`;
  headers.forEach(header => {
    headerString += renderMainLeftCell(header);
  });
  headerString += `</tr>`;
  return headerString;
};

export const renderReturnsRow = data => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(data.fundAbbreviatedName);
  rowString += renderMainRightCell(formatReturnsValue(data.dailyReturnsYTD));
  rowString += renderMainRightCell(formatReturnsValue(data.returns1Yr));
  rowString += renderMainRightCell(formatReturnsValue(data.returns3Yr));
  rowString += renderMainRightCell(formatReturnsValue(data.returns5Yr));
  rowString += renderMainRightCell(formatReturnsValue(data.returns10Yr));
  rowString += renderMainRightCell(formatReturnsValue(data.returnsLTD));
  rowString += `</tr>`;
  return rowString;
};

export const renderIndexReturnsRow = data => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(data.indexLabel);
  rowString += renderMainRightCell(formatReturnsValue('N/A'));
  rowString += renderMainRightCell(formatReturnsValue(data.indexReturns1Yr));
  rowString += renderMainRightCell(formatReturnsValue(data.indexReturns3Yr));
  rowString += renderMainRightCell(formatReturnsValue(data.indexReturns5Yr));
  rowString += renderMainRightCell(formatReturnsValue(data.indexReturns10Yr));
  rowString += renderMainRightCell('N/A');
  rowString += `</tr>`;
  return rowString;
};

export const renderSEC30DayYieldRow = sec30DayYield => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(sec30DayYield.excelLabel);
  rowString += renderMainRightCell(sec30DayYield.data);
  rowString += renderColumnGaps();
  rowString += renderSoftLeftCell(sec30DayYield.asOfDate);
  rowString += `</tr>`;
  return rowString;
};

export const returnsAtNavModule = (monthly, quarterly, dates, sec30DayYield) => {
  let returnsAtNavString = ``;
  returnsAtNavString += renderSectionHeaderAsOfDate('Month-End Returns at NAV', `as of ${dates.MonthlyAsOfDate}`);
  returnsAtNavString += renderRowGaps();
  returnsAtNavString += returnsAtNavHeaderRow(monthly.headers);
  returnsAtNavString += renderReturnsRow(monthly);
  returnsAtNavString += renderIndexReturnsRow(monthly);
  returnsAtNavString += renderRowGaps(2);
  returnsAtNavString += renderSectionHeaderAsOfDate('Quarter-End Returns at NAV', `as of ${dates.QtrAsOfDate}`);
  returnsAtNavString += renderRowGaps();
  returnsAtNavString += returnsAtNavHeaderRow(quarterly.headers);
  returnsAtNavString += renderReturnsRow(quarterly);
  returnsAtNavString += renderIndexReturnsRow(quarterly);
  returnsAtNavString += renderSEC30DayYieldRow(sec30DayYield);
  returnsAtNavString += renderRowGaps(2);
  return returnsAtNavString;
};
